import getRequest from '../utils/getRequest'
import postRequest from '../utils/postRequest'
import deleteRequest from '../utils/deleteRequest'
import filterUndefinedFromObject from '../utils/filterUndefinedFromObject'
import patchRequest from '../utils/patchRequest'

const path = '/api/site'
const reassessmentPath = '/api/reassessment/sites'

export const getCongregationsList = (siteId, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/species-congregations` : `${path}/${siteId}/species-congregations`
  return getRequest(url)
}

export const createCongregationsItem = (siteId, congregationId, siteHistoryId ) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/species-congregations` : `${path}/${siteId}/species-congregations`
  return postRequest(url, {
    CongregationGroupId: congregationId
  })
}

export const removeSpeciesCongregation = (siteId, congregationId, siteHistoryId, congregationHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/species-congregations/${congregationHistoryId}` : `${path}/${siteId}/species-congregations/${congregationId}`
  return deleteRequest(url)
}

export const updateSpeciesCongregation = (siteId, congregationId, siteHistoryId, congregationHistoryId, {
  best,
  description,
  max,
  min,
  year_min,
  year_max,
  season_id,
  trigger_reason_id,
  trigger_reason_text
}) => {
  const requestBody = filterUndefinedFromObject({
    best,
    description,
    max,
    min,
    year_min,
    year_max,
    season_id,
    trigger_reason_id,
    trigger_reason_text
  })

  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/species-congregations/${congregationHistoryId}` : `${path}/${siteId}/species-congregations/${congregationId}`

  return patchRequest(url, requestBody)
}

export const getCalculationCongregations = (siteId, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/congregations/congregation-criterias` : `${path}/${siteId}/congregation-criterias`
  return getRequest(url)
}

export const getSeasonalDistributions = () => {
  return getRequest('/api/seasonal-distributions')
}

